import React, { useEffect, useState } from 'react';

import styles from "./CardDesignSelect.module.css";
import { useTranslation } from 'react-i18next';
import {getVersionUrl} from 'common/cacheOverwrite';

type CardDesignOptionProps = {
  screenId: string;
  cardProductCode?: string;
  designDivisionCode: string;
  isSelected?: boolean;
  onClick?: () => void;
}

const CardDesignOption: React.FC<CardDesignOptionProps> = ({screenId, cardProductCode , designDivisionCode, isSelected, onClick}) => {
  const { t } = useTranslation();

  const [cardDesignUrl, setCardDesignUrl] = useState<string>();

  const [optionHeader, setOptionHeader] = useState("");

  const handleOptionClick = () => {
    onClick?.();
  }

  useEffect(() => {
    // "https://devcard.gmoneytrans.net/images/products/gmoney-card_100921_B.png"
    setCardDesignUrl(localStorage.getItem(`${cardProductCode}_${designDivisionCode}`) as string);

    if (designDivisionCode === "C") {
      setOptionHeader(t(`${screenId}.TEXT_3`, "Hanguel Card"));
    } else if (designDivisionCode === "B") {
      setOptionHeader(t(`${screenId}.TEXT_5`, "Dancheong Card"));
    }
// eslint-disable-next-line
  }, [cardProductCode, designDivisionCode]);

  return (
    <div className={styles.cardDesignOption} onClick={handleOptionClick}>
      <img className={`${styles.image} ${isSelected !== undefined && !isSelected ? styles.unselected: ""}`} alt={"Card Product"} src={getVersionUrl(cardDesignUrl)}/>
      <div className={`${styles.header} ${isSelected ? styles.selected : ""} ${isSelected !== undefined && !isSelected ? styles.unselected: ""}`}>{optionHeader}</div>
      <img className={styles.radioButton} alt={"Card Product Select Radio Button"} src={getVersionUrl(isSelected ? "/assets/images/ico/ic_radio_selected_24.png" : "/assets/images/ico/ic_radio_unselected_24.png")}></img>
    </div>
  );
}

export default CardDesignOption;